import { Async, AsyncErrorHandling, Rejected, Resolved } from '../../../common/async';
import { ReportModel } from '../models/report-model';
import * as reportService from '../report-service';
import { useParams } from 'react-router';
import { ReactNode } from 'react';

const getReport = ({ teamId, runId }) => reportService.getReport(teamId, runId);

export interface FetchReportProps {
    children: (report: ReportModel, teamId: string) => ReactNode;
}

export const FetchReport = ({ children }: FetchReportProps) => {
    const { teamId, surveyRunId } = useParams();

    return (
        <Async promiseFn={getReport} teamId={teamId} runId={surveyRunId}>
            <Resolved>{report => children(report, teamId)}</Resolved>
            <Rejected>{error => <AsyncErrorHandling error={error} />}</Rejected>
        </Async>
    );
};

export default FetchReport;
